import src from "IMAGE";
export default { src, width: 916, height: 161, blurWidth: 0, blurHeight: 0};
